import { render, staticRenderFns } from "./addCaseDialog.vue?vue&type=template&id=6cf28acd&scoped=true&"
import script from "./addCaseDialog.vue?vue&type=script&lang=js&"
export * from "./addCaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./addCaseDialog.vue?vue&type=style&index=0&id=6cf28acd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf28acd",
  null
  
)

export default component.exports